import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { ActivitySubscriptionsEffects } from './store/activity-subscriptions/activity-subscriptions.effects';
import {
  ActivitySubscriptionsNamespace,
  ActivitySubscriptionsReducer,
} from './store/activity-subscriptions/activity-subscriptions.store';
import { ActivitySubscriptionsPerRoleEffects } from './store/activity-subscriptions-per-role/activity-subscriptions-per-role.effects';
import {
  ActivitySubscriptionsPerRoleNamespace,
  ActivitySubscriptionsPerRoleReducer,
} from './store/activity-subscriptions-per-role/activity-subscriptions-per-role.store';
import { NotificationsCounterEffects } from './store/notification-counter/notification-counter.effects';
import {
  NotificationsCounterNamespace,
  NotificationsCounterReducer,
} from './store/notification-counter/notification-counter.store';
import { NotificationsCounterFilteredEffects } from './store/notification-counter-filtered/notification-counter-filtered.effects';
import {
  NotificationsCounterFilteredNamespace,
  NotificationsCounterFilteredReducer,
} from './store/notification-counter-filtered/notification-counter-filtered.store';
import { NotificationsEffects } from './store/notifications/notifications.effects';
import {
  NotificationsNamespace,
  NotificationsReducer,
} from './store/notifications/notifications.store';
import { TrackingActivitiesEffects } from './store/tracking-activities/tracking-activities.effects';
import {
  TrackingActivitiesNamespace,
  TrackingActivitiesReducer,
} from './store/tracking-activities/tracking-activities.store';

@NgModule({
  imports: [
    StoreModule.forFeature(ActivitySubscriptionsNamespace, ActivitySubscriptionsReducer),
    StoreModule.forFeature(NotificationsNamespace, NotificationsReducer),
    StoreModule.forFeature(TrackingActivitiesNamespace, TrackingActivitiesReducer),
    StoreModule.forFeature(
      ActivitySubscriptionsPerRoleNamespace,
      ActivitySubscriptionsPerRoleReducer,
    ),
    StoreModule.forFeature(NotificationsCounterNamespace, NotificationsCounterReducer),
    StoreModule.forFeature(
      NotificationsCounterFilteredNamespace,
      NotificationsCounterFilteredReducer,
    ),
    EffectsModule.forFeature([
      ActivitySubscriptionsEffects,
      NotificationsEffects,
      TrackingActivitiesEffects,
      NotificationsCounterEffects,
      NotificationsCounterFilteredEffects,
      ActivitySubscriptionsPerRoleEffects,
    ]),
  ],
})
export class ActivitiesAndNotificationsDataStoreModule {}
